export * from '../rawr/apps/cbportal';



/** WEBPACK FOOTER **
 ** collegeboard/client/entries/portal.js
 **/